import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleable"]

  connect() {
    // Initialize visibility based on checkbox state
    this.updateVisibility()
  }

  toggle(event) {
    this.updateVisibility()
  }

  updateVisibility() {
    const checkbox = this.element.querySelector('input[type="checkbox"][name*="recurring"]')

    if (!checkbox) return

    this.toggleableTargets.forEach(element => {
      if (checkbox.checked) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })
  }
}
